import { NodeTemplatePart } from '@github/template-parts';
export function processDocumentFragment(part, value) {
    if (value instanceof DocumentFragment && part instanceof NodeTemplatePart) {
        if (value.childNodes.length)
            part.replace(...value.childNodes);
        return true;
    }
    return false;
}
//# sourceMappingURL=document-fragment.js.map